export default {"src":"/_next/static/media/logo.f93e43fa.svg","height":50,"width":140,"blurWidth":0,"blurHeight":0};